import axios from "axios";
import { buildHeaders } from "../_headers.util";
import { resolveApiBaseUrl } from "@/utils/hostname";

const dashboardPath = "super-admin/dashboard";

export default {
  get(params = {}) {
    return axios.get(`${resolveApiBaseUrl()}${dashboardPath}`, {
      params,
      headers: buildHeaders(),
    });
  },
};
